/**
 * User-visible copy for multi-instance Power Distribution list + per-unit editor
 * (#996 — Facility Power / Power Distribution).
 * Mirrors largeUpsConfigurationsSubsectionCopy.
 */

export const POWER_DISTRIBUTION_CONFIGURATIONS_LIST_TITLE =
  'Power Distribution units';

export const POWER_DISTRIBUTION_CONFIGURATIONS_LIST_SUBTITLE =
  'Each row is one power distribution feed. Select a row to edit, or add a new unit below.';

export const POWER_DISTRIBUTION_EDIT_DETAILS_CARD_SUBTITLE =
  'UPS output voltage, distribution voltage, busway, amperage, length, and tap off box for this feed.';

/** Standalone Power Distribution step — step-level Additional Information (#997 / #1330). */
export const POWER_DISTRIBUTION_ADDITIONAL_INFORMATION_SUBTITLE =
  'Extra notes or attachments for power distribution on this request.';

export const POWER_DISTRIBUTION_ADDITIONAL_INFORMATION_LABEL =
  'Additional Power Distribution Information';

export const POWER_DISTRIBUTION_ADDITIONAL_INFORMATION_PLACEHOLDER =
  'Enter additional power distribution information';

export const POWER_DISTRIBUTION_EDIT_ALL_UNITS_LABEL = 'All Power Distribution';

export const POWER_DISTRIBUTION_EDIT_HEADER_TITLE_NEW =
  'New Power Distribution';

export const POWER_DISTRIBUTION_EDIT_STATUS_EXISTING_LABEL = 'Existing';

export const POWER_DISTRIBUTION_EDIT_STATUS_NEW_LABEL = 'New';

export const POWER_DISTRIBUTION_EDIT_TYPE_LABEL = 'Power Distribution type';

/** Display labels for {@link FormTwoOptionChoice} — map to `status` existing | new. */
export const POWER_DISTRIBUTION_EDIT_TYPE_OPTIONS = [
  POWER_DISTRIBUTION_EDIT_STATUS_EXISTING_LABEL,
  POWER_DISTRIBUTION_EDIT_STATUS_NEW_LABEL,
] as const;

export const POWER_DISTRIBUTION_EDIT_DELETE_LABEL = 'Delete';

export const POWER_DISTRIBUTION_EDIT_SAVE_LABEL = 'Save Power Distribution';

/** Create Request / draft flow — clarifies save is local to the step list. */
export const POWER_DISTRIBUTION_EDIT_SAVE_DRAFT_LABEL =
  'Save Power Distribution';

export const POWER_DISTRIBUTION_EDIT_SAVE_DRAFT_HINT =
  'Adds this unit to the list. Save the request separately when ready.';

export const POWER_DISTRIBUTION_ROW_ACTION_EDIT_LABEL = 'Edit';

export const POWER_DISTRIBUTION_ROW_ACTION_VIEW_LABEL = 'View';

export const POWER_DISTRIBUTION_ROW_ACTION_DUPLICATE_LABEL = 'Duplicate';

/** List row overflow menu — short action labels (editor footer uses {@link POWER_DISTRIBUTION_EDIT_DELETE_LABEL}). */
export const POWER_DISTRIBUTION_ROW_ACTION_DELETE_LABEL = 'Delete';

export const POWER_DISTRIBUTION_DELETE_CONFIRM_TITLE =
  'Delete Power Distribution Configuration';

export const POWER_DISTRIBUTION_DELETE_CONFIRM_MESSAGE =
  'Are you sure you want to delete this power distribution configuration? This cannot be undone.';

export const POWER_DISTRIBUTION_DISCARD_UNSAVED_TITLE = 'Unsaved Changes';

export const POWER_DISTRIBUTION_DISCARD_UNSAVED_MESSAGE =
  'You have unsaved changes. Discard them?';

export const POWER_DISTRIBUTION_DISCARD_UNSAVED_KEEP_EDITING_LABEL = 'Stay';

export const POWER_DISTRIBUTION_DISCARD_UNSAVED_DISCARD_LABEL = 'Discard';
